import { Benchmark } from "./types/benchmark.type";

export interface GetVideoBenchmarkReq {
  projectId: string;
  studyId: string;
}

// TODO(DFP-1117): Replace this mock with a real call to api-studio once the benchmark endpoint exists.
const MOCK_VIDEO_BENCHMARK: Benchmark = {
  id: "broadcast-tv",
  name: "Broadcast TV",
  videoCount: 3986,
  scoreRangeMin: 55,
  scoreRangeMax: 75,
};

/*
 * getVideoBenchmark endpoint
 *
 * Mocked until the api-studio benchmark endpoint is ready. Returns the benchmark applied
 * to a video study's Creative Impact scores, for comparison against each asset's own score.
 */
export const getVideoBenchmark = async (req: GetVideoBenchmarkReq): Promise<Benchmark> => {
  void req; // projectId/studyId will become URL params once this calls the real endpoint
  return Promise.resolve(MOCK_VIDEO_BENCHMARK);
};
